import React, {Suspense, useState, useCallback, useEffect } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
//import Users from './user/pages/Users';
//import Auth from './user/pages/Auth';
//import NewPlace from './places/pages/NewPlace';
//import UserPlaces from './places/pages/UserPlaces';
//import UpdatePlace from './places/pages/UpdatePlace';
import MainNavigation from './shared/components/Navigation/MainNavigation';
import  AuthContex  from './shared/context/authcontext';
import jwt_decode from 'jwt-decode';
import LoadingSpinner from './shared/components/UIElements/LoadingSpinner';

const Users = React.lazy(() => import('./user/pages/Users'));
const NewPlace = React.lazy(() => import('./places/pages/NewPlace'));
const UserPlaces = React.lazy(() => import('./places/pages/UserPlaces'));
const UpdatePlace = React.lazy(() => import('./places/pages/UpdatePlace'));
const Auth = React.lazy(() => import('./user/pages/Auth'));

let logoutTimer;
     
function App() {
    const [token, setToken] = useState(false);
    const [userId, setUserId] = useState(false);
    const [tokenExpirationDate, setTokenExpirationDate] = useState();
 
    const login = useCallback((uid, token) => {
        setToken(token);
        setUserId(uid);
        setTokenExpirationDate(jwt_decode(token).exp);
 
        localStorage.setItem(
            'userData',
            JSON.stringify({
                userId: uid,
                token: token,
            })
        );
    }, []);
 
    const logout = useCallback(() => {
        setToken(null);
        setUserId(null);
        setTokenExpirationDate(null);
        localStorage.removeItem('userData');
    }, []);
 
    useEffect(() => {
        if (token && tokenExpirationDate) {
            const remainingTime = tokenExpirationDate * 1000 - Date.now();
            //expected time in setTimeout is in milliseconds, hence the *1000
            logoutTimer = setTimeout(logout, remainingTime);
        } else {
            clearTimeout(logoutTimer);
        }
    }, [token, logout, tokenExpirationDate]);
 
    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem('userData'));
 
        if (storedData && storedData.token) {
            const localTokenExpirationDate = jwt_decode(storedData.token).exp;
 
            if (localTokenExpirationDate > Date.now() / 1000) {
                login(storedData.userId, storedData.token);
            }
        }
    }, [login]);
 
 let routes;
  if (token){
    routes = (
      <Switch>
        <Route path="/" exact>
          <Users />
        </Route>
        <Route path="/:userId/places" exact>
          <UserPlaces />
        </Route>
        <Route path="/places/new" exact>
          <NewPlace />
        </Route>
        <Route path="/places/:placeId" exact>
          <UpdatePlace />
        </Route>
        <Redirect to="/" />
      </Switch>
    );
  }else {
    routes = (
      <Switch>
        <Route path="/" exact>
          <Users />
        </Route>
        <Route path="/:userId/places" exact>
          <UserPlaces />
        </Route>
        <Route path="/auth" >
          <Auth />
        </Route>
        <Redirect to="/auth" />
      </Switch>
      
    );
  }
  return (
    <AuthContex.Provider 
      value={{ 
        isLoggedIn: !!token,
        token: token, 
        userId: userId, 
        login: login, 
        logout: logout 
      }}
    >
      <Router>
        <MainNavigation />
        <main>
            <Suspense 
              fallback={<div className="center"> <LoadingSpinner/> </div>}
            >
              {routes}
            </Suspense>
        </main>
      </Router>
    </AuthContex.Provider>
  
  );
 
}

  
export default App;
